import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import style from "../../newUser/newUser.module.css"; // Using your existing shared styles
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { useSaveBlockedPlot, useBlockedPlot } from "../../../hooks/blockedPlot.hooks";

const AddBlockedPlotMapping = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const isEditMode = !!id;
    const { mutate: saveBlockedPlot, isPending } = useSaveBlockedPlot();
    const { data: existingData, isLoading } = useBlockedPlot(id ? parseInt(id) : undefined);

    const [formData, setFormData] = useState({
        id: 0,
        mauja: "",
        khasaraNo: "",
        plotNo: "",
        active: true,
    });

    useEffect(() => {
        if (existingData) {
            console.log("Existing active value:", existingData?.active, typeof existingData?.active);
            setFormData({
                id: existingData.id,
                mauja: existingData.mauja,
                khasaraNo: existingData.khasaraNo,
                plotNo: existingData.plotNo,
                active: String(existingData.active) === "true" ||
                    String(existingData.active) === "1",
            });
        }
    }, [existingData]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const alphaNumericRegex = /^[a-zA-Z0-9]*$/;

        if (!alphaNumericRegex.test(value)) {
            return; // Prevent invalid input
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData((prev) => ({
            ...prev,
            active: e.target.checked,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.mauja || !formData.khasaraNo || !formData.plotNo) {
            ErrorToast("Please fill all mandatory fields");
            return;
        }

        const payload = isEditMode ? formData : {
            mauja: formData.mauja,
            khasaraNo: formData.khasaraNo,
            plotNo: formData.plotNo,
            active: formData.active
        };

        saveBlockedPlot(payload as any, {
            onSuccess: () => {
                // SuccessToast is already handled in the hook
                navigate("/blocked-plot-mapping");
            },
        });
    };
    const isFormValid =
        formData.mauja.trim() !== "" &&
        formData.khasaraNo.trim() !== "" &&
        formData.plotNo.trim() !== "";

    if (isLoading && isEditMode) return <BoxComponent>Loading...</BoxComponent>;
    return (
        <div className={style.body}>
            <form onSubmit={handleSubmit}>
                <div className={style.bodytitle}>
                    {isEditMode ? "Edit Blocked Plot Mapping" : "Add Blocked Plot Mapping"}
                </div>
                <BoxComponent>
                    <div className={style.bodyBox}>
                        {/* Row 1: Mauja and Khasara Number */}
                        <div className={`${style.formrow} items-end`}>                            <div className={style.formgroup}>
                                <label className={style.loginText}>
                                    Mauja <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="mauja"
                                    className={`${style.inputcontainer} border border-gray-300 rounded-md focus:border-blue-500 px-4 py-2`}
                                    placeholder="Enter Mauja"
                                    value={formData.mauja}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className={style.formgroup}>
                                <label className={style.loginText}>
                                    Khasara Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="khasaraNo"
                                    className={`${style.inputcontainer} border border-gray-300 rounded-md focus:border-blue-500 px-4 py-2`}
                                    placeholder="Enter Khasara Number"
                                    value={formData.khasaraNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        {/* Row 2: Plot Number and Status */}
                        <div className={`${style.formrow} items-end`}>                            <div className={style.formgroup}>
                                <label className={style.loginText}>
                                    Plot Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="plotNo"
                                    className={`${style.inputcontainer} border border-gray-300 rounded-md focus:border-blue-500 px-4 py-2`}
                                    value={formData.plotNo}
                                    placeholder="Enter Plot Number"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className={style.formgroup}>
                                <div className={`${style.footerActive} flex items-center gap-3`}>
                                    <label className={style.footerAct}>Status</label>
                                    <div className={style.footerAct}>
                                        <label className={style.toggleBtn}>
                                            <input
                                                type="checkbox"
                                                className={style.inputCheckbox}
                                                checked={formData.active}
                                                onChange={handleToggleChange}
                                            />
                                            <span className={style.slider}></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Button Section */}
                        <div className={`${style.buttonSection} mt-10 flex justify-center`}>                            <button
                                type="submit"
                                className="bg-primary ml-4 px-8 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
                                disabled={isPending || !isFormValid}
                            >
                                {isPending ? "Processing..." : (isEditMode ? "Update" : "Save")}
                            </button>
                            <button
                                type="button"
                                className="bg-black ml-4 px-8 py-2 font-bold text-white rounded-full"
                                onClick={() => navigate("/blocked-plot-mapping")}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </BoxComponent>
            </form>
        </div>
    );
};

export default AddBlockedPlotMapping;
